import { render, staticRenderFns } from "./ModalSubcategories.vue?vue&type=template&id=22d2fee0&scoped=true&"
import script from "./ModalSubcategories.vue?vue&type=script&lang=js&"
export * from "./ModalSubcategories.vue?vue&type=script&lang=js&"
import style0 from "./ModalSubcategories.vue?vue&type=style&index=0&id=22d2fee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d2fee0",
  null
  
)

export default component.exports